define(['jquery'], function ($) {

	var ERVPopup = function () {
		var self = this;
		self.$ervBody = $('#erv-body');

	};
	
	ERVPopup.prototype.openPopup = function (selector, callbacks, closeInside, modal) {
		var self = this;
		require(['magnific_popup'], function () {
			if (self.$ervBody.find('.lightbox').length) {
				$.magnificPopup.open({
					items: { src: selector, type: 'inline' },
					preloader: true,
					alignTop: true,
					fixedContentPos: true,
					closeBtnInside: closeInside,
					closeMarkup: '<button title="Exit (ESC)" type="button" class="mfp-close btn blue notranslate">X</button>',
					modal: modal,
					callbacks: callbacks
				});
			}
		});
	}
	
	return ERVPopup;
});